// «Деньги»: оплаты месяца, разбор выписки, чеки «Мой налог», итоги; окно оплаты и запись наличных.
import { RECEIPT, RU_MONTHS, addMonths, isCommercial, monthOf, money, pad2, plural, ruDateShort, ruMonth,
  type ClientOut, type GroupOut, type PaymentOut } from '@praktika/core';
import { afterChange, call, rpc } from '../lib/api.ts';
import { $, $$, copyText, esc, toast } from '../lib/dom.ts';
import { clientById, groupById } from '../lib/data.ts';
import { SCREENS, current, fab, go, render } from '../lib/nav.ts';
import { IC, chooseSheet, closeSheet, curSheet, openSheet, opt, promptSheet } from '../lib/sheet.ts';
import { S, UI, type MoneyView } from '../lib/state.ts';
import { nowInfo } from '../lib/zones.ts';
import { bindCommon, pickClient } from './common.ts';

// «в сентябре», «в мае», «в августе»
function inMonth(ym: string): string {
  return RU_MONTHS[Number(ym.slice(5, 7)) - 1]!.replace(/ь$/, 'е').replace(/й$/, 'е').replace(/т$/, 'те');
}

function payDue(pays: string, payDay: number | null, ym: string): string {
  return pays === 'monthly' ? ' · срок ' + (payDay || 5) + '.' + pad2(Number(addMonths(ym, 1).slice(5, 7))) : '';
}

SCREENS.money = (app) => {
  const n = nowInfo();
  if (!UI.moneyMonth) UI.moneyMonth = monthOf(n.date);
  const ym = UI.moneyMonth, M = UI.money && UI.money.month === ym ? UI.money : null;
  if (!M) {
    rpc<MoneyView>('money', ym).then((d) => { UI.money = d; if (current().name === 'money') render(); },
      (e: Error) => toast(e.message, true));
  }
  const seg = UI.moneySeg, rc = S.counts.review || 0, rq = S.counts.receipts || 0;
  let html = '<div class="p-title"><span class="t">Деньги</span><button class="sub" data-month style="color:#2563eb">' +
    esc(ruMonth(ym)) + ' ▾</button></div>' +
    '<div class="seg"><button' + (seg === 'pay' ? ' class="on"' : '') + ' data-seg="pay">Оплаты</button><button' +
    (seg === 'review' ? ' class="on"' : '') + ' data-seg="review">К разбору' + (rc ? '<i class="n">' + rc + '</i>' : '') +
    '</button><button' + (seg === 'rc' ? ' class="on"' : '') + ' data-seg="rc">Чеки' +
    (rq ? '<i class="n">' + rq + '</i>' : '') + '</button><button' + (seg === 'tot' ? ' class="on"' : '') +
    ' data-seg="tot">Итоги</button></div>';
  if (seg === 'pay') {
    const pays = S.payments.filter((p) => monthOf(p.date) === ym).sort((a, b) => a.date < b.date ? 1 : -1);
    html += (M ? '<div class="p-sum">Получено в ' + esc(inMonth(ym)) + ': <b>' +
      esc(money(Math.round(M.totals.receivedMain), M.totals.main)) + '</b> ≈ ' +
      esc(money(Math.round(M.totals.receivedSec), M.totals.sec)) + '</div>' : '<div class="p-sum">считаю…</div>') +
      '<div class="p-list">' + (pays.map((o) => {
        const proj = isCommercial(groupById(o.payerId));
        return '<button class="p-row pay" data-pay="' + esc(o.id) + '"><div class="who"><div class="n">' +
          esc(o.payerName || o.sender || '—') + (proj ? ' <span class="tag p">проект</span>' : '') +
          '</div><div class="i">' + esc(ruDateShort(o.date)) + ' · ' +
          esc(o.source === 'наличные' ? 'наличные' : 'выписка ' + o.source) +
          (o.receipt === RECEIPT.NEED ? ' · <span class="neg">чек не выбит</span>' :
            o.receipt === RECEIPT.DONE ? ' · чек выбит ✓' : '') +
          (o.note ? ' · ' + esc(o.note) : '') + '</div></div><div class="amt pos">+' + esc(money(o.amount, o.cur)) +
          '</div></button>';
      }).join('') || '<div class="empty">Оплат за ' + esc(ruMonth(ym)) + ' нет</div>') + '</div>';
  } else if (seg === 'review') {
    // поступления из выписок без хозяина — с загрузкой выписок
    html += '<div class="p-sum">Всё разобрано.</div>' +
      '<div class="btnrow"><button class="btn sec" data-go="import">Загрузить выписку</button></div>';
  } else if (seg === 'rc') {
    const recs = M ? M.receipts : [], need = recs.filter((r) => r.status === RECEIPT.NEED);
    html += '<div class="p-sum">Только рубли · не выбито <b>' + need.length + '</b>' + (M ? ' · налог за ' +
      esc(RU_MONTHS[Number(ym.slice(5, 7)) - 1]) + ' ≈ <b>' + esc(money(M.taxEstimate, 'RUB')) + '</b>' : '') + '</div>';
    if (!M) html += '<div class="empty">считаю…</div>';
    for (const r of recs) {
      html += '<div class="card" data-rc="' + esc(r.id) + '"><div class="kv col"><span class="v">' +
        esc(money(r.amount, r.cur)) + ' · ' + esc(ruDateShort(r.date)) + ' · ' + esc(r.buyer) + '</span><span class="k">' +
        esc(r.kind) + ' · «' + esc(r.service) + '» · срок ' + esc(ruDateShort(r.due)) +
        (r.status === RECEIPT.DONE ? ' · <span class="pos">выбит ✓</span>' : '') +
        '</span></div><div class="chips"><button class="chp" data-copy="' + esc(r.amount) + '">Скопировать сумму</button>' +
        (r.status === RECEIPT.NEED ? '<button class="chp" data-done>Выбит ✓</button><button class="chp" data-no>Не нужен</button>' :
          '<button class="chp" data-link>' + (r.link ? 'Ссылка на чек ✓' : 'Вставить ссылку на чек') +
          '</button><button class="chp" data-undone>Не выбит</button>') + '</div></div>';
    }
    if (M && !recs.length) html += '<div class="empty">Чеков нет: рублёвых оплат с отмеченных источников не было</div>';
  } else if (!M) {
    html += '<div class="empty">считаю…</div>';
  } else {
    const T = M.totals, P = T.personal;
    html += '<div class="p-sum">' + esc(ruMonth(ym)) + ' · <b>' + T.total.sessions + ' ' + plural(T.total.sessions,
      'сессия', 'сессии', 'сессий') + '</b></div>' +
      '<div class="card"><div class="hd">Личные клиенты · ' + P.sessions + ' ' + plural(P.sessions, 'сессия', 'сессии',
      'сессий') + '</div><div class="kv"><span class="k">Начислено</span><span class="v">' +
      esc(money(Math.round(P.chargedMain), T.main)) + '</span></div><div class="kv"><span class="k">Оплачено</span>' +
      '<span class="v">' + esc(money(Math.round(P.paidMain), T.main)) + '</span></div><div class="kv">' +
      '<span class="k">Долги</span><span class="v' + (P.debtMain ? ' neg' : '') + '">' + (P.debtMain ?
      esc(money(Math.round(P.debtMain), T.main)) + ' · ' + esc(P.debtors.join(', ')) : 'нет') + '</span></div></div>';
    for (const pb of T.projects) {
      html += '<div class="card"><div class="hd">' + esc(pb.name) + ' · ' + pb.sessions + ' ' + plural(pb.sessions,
        'сессия', 'сессии', 'сессий') + '</div><div class="kv"><span class="k">Начислено</span><span class="v">' +
        esc(money(pb.charged, pb.cur)) + payDue(pb.pays, pb.payDay, ym) + '</span></div><div class="kv"><span class="k">' +
        (pb.balance < 0 ? 'Долг проекта' : 'Баланс') + '</span><span class="v' + (pb.balance < 0 ? ' neg' :
        pb.balance > 0 ? ' pos' : '') + '">' + (pb.balance ? esc(money(Math.abs(pb.balance), pb.cur)) +
        (pb.balance > 0 ? ' аванс' : '') : (pb.paid >= pb.charged && pb.charged ? 'оплачено' : '0')) +
        '</span></div></div>';
    }
    html += '<div class="card"><div class="hd">Всего</div><div class="kv"><span class="k">Начислено</span>' +
      '<span class="v">≈ ' + esc(money(Math.round(T.total.chargedSec), T.sec)) + '</span></div><div class="kv">' +
      '<span class="k">Получено</span><span class="v">≈ ' + esc(money(Math.round(T.total.paidSec), T.sec)) +
      '</span></div></div>';
  }
  app.innerHTML = html;
  bindCommon(app);
  $('[data-month]', app).onclick = () => {
    const opts = [];
    for (let i = 0; i < 12; i++) { const m2 = addMonths(monthOf(n.date), -i); opts.push({ value: m2, label: ruMonth(m2) }); }
    chooseSheet('Месяц', opts, ym, (v) => { UI.moneyMonth = v; render(); });
  };
  $$('[data-seg]', app).forEach((b) => {
    b.onclick = () => { UI.moneySeg = b.getAttribute('data-seg') as typeof UI.moneySeg; render(); };
  });
  $$('[data-pay]', app).forEach((b) => { b.onclick = () => paymentSheet(b.getAttribute('data-pay')!); });
  $$('[data-rc]', app).forEach((card) => {
    const id = card.getAttribute('data-rc')!;
    const upd = (patch: Record<string, unknown>, msg: string) => void call('updatePayment', id, patch)
      .then(() => { UI.money = null; return afterChange(msg); }, () => {});
    const cp = $('[data-copy]', card);
    cp.onclick = () => copyText(String(cp.getAttribute('data-copy')));
    const d = $('[data-done]', card);
    if (d) d.onclick = () => upd({ receipt: RECEIPT.DONE }, 'Отмечено: выбит');
    const no = $('[data-no]', card);
    if (no) no.onclick = () => upd({ receipt: RECEIPT.NO, mytax: false }, 'Чек не нужен');
    const un = $('[data-undone]', card);
    if (un) un.onclick = () => upd({ receipt: RECEIPT.NEED }, 'Снова «нужен»');
    const ln = $('[data-link]', card);
    if (ln) ln.onclick = () => promptSheet('Ссылка на чек', '', 'url', (v) => upd({ receiptLink: v }, 'Ссылка сохранена'));
  });
  if (seg === 'pay') fab('Наличные', () => cashSheet(''));
  if (seg === 'review') fab('Выписка', () => go('import', {}));
};

function paymentSheet(id: string): void {
  const o: PaymentOut | undefined = S.payments.find((p) => p.id === id);
  if (!o) return;
  const sh = openSheet('<div class="ttl">' + esc(money(o.amount, o.cur)) + ' · ' + esc(ruDateShort(o.date)) +
    '</div><p class="sub">' + esc(o.payerName || '—') + ' · ' + esc(o.source) + (o.sender ? ' · ' + esc(o.sender) : '') +
    '</p>' + opt('', IC.ok, 'В Мой налог: ' + (o.mytax ? 'да' : 'нет'), o.cur === 'RUB' ? 'нажмите, чтобы переключить' :
    'только для рублей') + opt('', IC.edit, 'Комментарий', o.note || '') +
    opt('', IC.psy, 'Плательщик: ' + (o.payerName || 'не указан'), 'сменить') +
    (o.source === 'наличные' ? opt('no', IC.trash, 'Удалить оплату') : ''));
  const upd = (patch: Record<string, unknown>) => void call('updatePayment', id, patch)
    .then(() => { UI.money = null; return afterChange('Сохранено'); }, () => {});
  const bs = $$('button.opt', sh);
  bs[0]!.onclick = () => { if (o.cur !== 'RUB') return; closeSheet(); upd({ mytax: !o.mytax }); };
  bs[1]!.onclick = () => { closeSheet(); promptSheet('Комментарий', o.note, 'text', (v) => upd({ note: v })); };
  bs[2]!.onclick = () => { closeSheet(); pickClient((pid) => upd({ payerId: pid }), true); };
  if (bs[3]) bs[3].onclick = () => {
    if (!confirm('Удалить оплату?')) return;
    closeSheet();
    void call('deletePayment', id).then(() => { UI.money = null; return afterChange('Удалено'); }, () => {});
  };
}

// Оплата наличными на лицевой счёт клиента или проекта.
export function cashSheet(payerId: string): void {
  const st = { payerId: payerId || '', amount: '', cur: '', date: nowInfo().date, note: '' };
  const draw = () => {
    const c: ClientOut | null = st.payerId ? clientById(st.payerId) : null,
      g: GroupOut | null = st.payerId && !c ? groupById(st.payerId) : null, payer = c || g;
    const cur = st.cur || (c ? c.effCur || c.cur || S.settings.main_currency : g ? g.cur || S.settings.main_currency :
      S.settings.main_currency);
    const hint = c ? c.effPrice ?? c.price ?? '' : g ? g.price ?? '' : '';
    const sh = openSheet('<div class="ttl">Оплата наличными</div><p class="sub">Попадёт на лицевой счёт плательщика</p>' +
      '<button class="field" style="margin:0 0 8px;width:100%" data-payer><div class="l">От кого</div><div class="v"><span>' +
      (payer ? esc(payer.name) : '<span style="color:#9aa4b8;font-weight:400">выбрать…</span>') +
      '</span><span class="chev"></span></div></button>' +
      '<div class="field" style="margin:0 0 8px;width:100%"><div class="l">Сумма, ' + esc(cur) +
      '</div><input type="number" inputmode="decimal" data-amount value="' + esc(st.amount) + '" placeholder="' + hint +
      '"></div>' +
      '<div style="display:flex;gap:8px"><div class="field" style="margin:0 0 8px;flex:1"><div class="l">Дата</div>' +
      '<input type="date" data-date value="' + st.date + '"></div><button class="field" style="margin:0 0 8px;flex:0 0 100px" ' +
      'data-cur><div class="l">Валюта</div><div class="v"><span>' + esc(cur) + '</span><span class="chev"></span></div>' +
      '</button></div>' +
      '<div class="field" style="margin:0 0 12px;width:100%"><div class="l">Комментарий</div><input data-note value="' +
      esc(st.note) + '" placeholder="например, за 2 сессии"></div>' +
      '<div class="btnrow" style="padding:0"><button class="btn pri" data-ok' + (payer ? '' : ' disabled') +
      '>Записать оплату</button></div>');
    const amount = $<HTMLInputElement>('[data-amount]', sh), date = $<HTMLInputElement>('[data-date]', sh),
      note = $<HTMLInputElement>('[data-note]', sh);
    $('[data-payer]', sh).onclick = () => pickClient((id) => { st.payerId = id; st.cur = ''; draw(); }, true);
    amount.oninput = () => { st.amount = amount.value; };
    date.onchange = () => { st.date = date.value; };
    note.oninput = () => { st.note = note.value; };
    $('[data-cur]', sh).onclick = () => curSheet('Валюта', cur, (v) => { st.cur = v; draw(); });
    $('[data-ok]', sh).onclick = () => {
      const a = Number(String(st.amount).replace(',', '.'));
      if (!(a > 0)) { toast('Введите сумму', true); return; }
      closeSheet();
      void call('addPayment', { payerId: st.payerId, amount: a, cur, date: st.date, source: 'наличные', note: st.note })
        .then(() => { UI.money = null; return afterChange('Оплата записана'); }, () => {});
    };
    setTimeout(() => { if (payer) amount.focus(); }, 50);
  };
  draw();
}
